import React, {Fragment} from 'react';

import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid, Typography} from '@material-ui/core';

import {InferPropTypes} from 'commons/types/Types';
import {DashboardUsersValues} from 'commons/models';
import EfeDragAndDrop from 'components/efe-drag-and-drop/EfeDragAndDrop';
import {EfeButtonPrimary, EfeErrorMsg, EfeSupportMessage} from 'components';
import {FileWithPath} from 'react-dropzone';

InnerFormDashboardUsers.propTypes = {};

/* eslint-disable react/jsx-handler-names */
function InnerFormDashboardUsers(
    props: InferPropTypes<
        typeof InnerFormDashboardUsers.propTypes & FormikProps<DashboardUsersValues>
    >
) {
    const {isSubmitting, values, setFieldValue, errors} = props;

    const [uploadedFiles, setUploadedFiles] = React.useState<Array<FileWithPath>>([]);

    function uploadFile(file: FileWithPath) {
        if (file) {
            setUploadedFiles([file]);
            const reader = new FileReader();
            reader.onload = () => {
                setFile(reader.result ? reader.result : '');
            };
            reader.readAsDataURL(file);
        }
    }

    function deleteFile(index: number) {
        if (uploadedFiles && uploadedFiles.length) {
            uploadedFiles.splice(index, 1);
            const aux = [...uploadedFiles];
            setUploadedFiles(aux);
            setFieldValue('file', '');
        }
    }

    function setFile(file: string | ArrayBuffer) {
        setFieldValue('file', file);
    }

    return (
        <Fragment>
            <Form noValidate>
                <Box m={2}>
                    <EfeSupportMessage />
                    <Box mt={4} mb={2}>
                        <Typography variant='body2' color='textPrimary'>
                            {'Carga de usuarios'}
                        </Typography>
                    </Box>

                    <EfeDragAndDrop
                        maxSizeFile={10}
                        numFiles={1}
                        file={values.file}
                        fileList={uploadedFiles}
                        deleteFile={deleteFile}
                        loadFile={uploadFile}
                        formatOverride={'text/csv'}
                        formatOverrideLabel={'Formato: .csv'}
                    />
                    {errors.file && (
                        <Box>
                            <EfeErrorMsg message={errors.file} />
                        </Box>
                    )}
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            </Form>
        </Fragment>
    );
}

export default InnerFormDashboardUsers;
